import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import { useTranslation } from 'react-i18next';

const ShoppingBagEmptyIcon = styled.div`
  width: 5.257vw;
  height: 5.257vw;

  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.grayIcons};
  font-size: 5.7vw;
`;

const Wrapper = styled.div`
  position: absolute;
  top: ${(props) => (props.display ? '22.466vw' : '10vw')};
  opacity: ${(props) => (props.display ? '1' : '0')};
  visibility: ${(props) => (props.display ? 'visible' : 'hidden')};
  left: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  transition: 200ms ease-in-out;
`;

const StyledDiv = styled.div`
  margin-top: 1.04vw;
  font-size: 1.145vw;
  font-weight: 500;
  color: ${(props) => props.theme.textSecondary};
`;

const App = (props) => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const { display } = props;
  return (
    <Wrapper display={display}>
      <ShoppingBagEmptyIcon className="icon-shopping-bag-empty" theme={theme} />
      <StyledDiv theme={theme}>{t('cart.empty.Your Cart is empty')}</StyledDiv>
    </Wrapper>
  );
};

export default App;
